import Select from 'react-select';
import { getAttendanceColor } from '@/shared/lib/utils/getColorClass';

export interface AttendanceOption {
  value: string;
  label: string;
}

export interface AttendanceSelectProps {
  name: string;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
}

const attendanceOptions: AttendanceOption[] = [
  { value: '0', label: '0.0' },
  { value: '0.5', label: '0.5' },
  { value: '1', label: '1.0' },
];

export const AttendanceSelect = (props: AttendanceSelectProps) => {
  const { name, onChange, value, placeholder = 'Select', disabled = false } = props;

  const selectedOption = value ? attendanceOptions.find((option) => option.value === value) : null;

  const colors = getAttendanceColor(value || null);

  const handleSelectChange = (selectedOption: any) => {
    const newValue = selectedOption?.value || '';
    onChange?.(newValue);
  };

  return (
    <div style={{ width: '90px' }}>
      <Select
        instanceId={name}
        name={name}
        options={attendanceOptions}
        value={selectedOption}
        onChange={handleSelectChange}
        placeholder={placeholder}
        isSearchable={false}
        isClearable={false}
        isDisabled={disabled}
        menuPlacement="bottom"
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
          }),
          control: (base) => ({
            ...base,
            minHeight: '40px',
            height: '40px',
            borderRadius: '8px',
            border: value ? 'none' : '1px solid #e4e7ec',
            boxShadow: 'none',
            outline: 'none',
            backgroundColor: colors.bg,
            paddingLeft: '12px',
            paddingRight: '4px',
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.6 : 1,
          }),
          valueContainer: (base) => ({
            ...base,
            padding: '0',
            margin: '0',
          }),
          input: (base) => ({
            ...base,
            margin: '0',
            padding: '0',
            color: colors.text,
            fontSize: '14px',
          }),
          placeholder: (base) => ({
            ...base,
            color: '#8C8C8C',
            fontSize: '14px',
            margin: '0',
          }),
          singleValue: (base) => ({
            ...base,
            color: colors.text,
            fontSize: '14px',
            fontWeight: 500,
            margin: '0',
          }),
          indicatorSeparator: () => ({
            display: 'none',
          }),
          dropdownIndicator: (base: any, state: any) => ({
            ...base,
            padding: '2px',
            color: colors.text,
            transition: 'transform 0.3s ease-in-out',
            transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            svg: {
              width: '16px',
              height: '16px',
            },
            '&:hover': {
              color: colors.text,
            },
          }),
          menu: (base) => ({
            ...base,
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            marginTop: '4px',
          }),
          menuList: (base) => ({
            ...base,
            padding: '4px',
          }),
          option: (base, state) => {
            const optionColors = getAttendanceColor(state.data.value);
            return {
              ...base,
              borderRadius: '4px',
              padding: '8px 12px',
              fontSize: '14px',
              lineHeight: '1.4',
              transition: 'background-color 0.3s ease-in-out',
              color: optionColors.text,
              backgroundColor: state.isSelected
                ? optionColors.bg
                : state.isFocused
                  ? optionColors.bg
                  : 'transparent',
              cursor: 'pointer',
              fontWeight: 500,
              '&:hover': {
                backgroundColor: optionColors.bg,
              },
            };
          },
        }}
      />
    </div>
  );
};
